import { render, staticRenderFns } from "./DettaglioPrenotazioneImpianto.vue?vue&type=template&id=5bcfc234&"
import script from "./DettaglioPrenotazioneImpianto.vue?vue&type=script&lang=js&"
export * from "./DettaglioPrenotazioneImpianto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports